import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import SoftLimits from '@/features/SoftLimits/components/SoftLimits.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Limits',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SoftLimits));
        };
    }
});
